<template>
  <div>

    <div class="styleone">
      <h4 style="margin-top:33px;margin-bottom:12px"><i class="fa fa-tag">&nbsp;</i>よく使うボタン</h4>
    </div>
    <div align="left">
      <el-button type="text" @click="jump('/companyInfo')">
        <i class="fa fa-briefcase icon_button"></i><br><br><br>
        会社情報
      </el-button>

      <el-button type="text" @click="jump('/empList')">
        <i class="fa fa-id-card-o icon_button"></i><br><br><br>
        従業員情報
      </el-button>

      <el-button type="text" @click="jump('/salary')">
        <i class="fa fa-credit-card icon_button"></i><br><br><br>
        給与明細
      </el-button>

      <el-button type="text" @click="jump('/empPDF')">
        <i class="fa fa-print icon_button"></i><br><br><br>
        労働者名簿印刷
      </el-button>

      <el-button type="text" @click="jump('/FileList')">
        <i class="fa fa-list-alt icon_button"></i><br><br><br>
        書類一覧
      </el-button>

      <el-button type="text" @click="jump('/UserHome')">
        <i class="fa fa-cog icon_button"></i><br><br><br>
        アカウント設定
      </el-button>

    </div>

    <div class="styleone">
      <h4 style="margin-top:20px;margin-bottom:12px"><i class="fa fa-bell">&nbsp;</i>システムからのお知らせ</h4>
    </div>

    <el-row>
      <el-col :span="24">
        <div class="purple-dark1">
          <el-link></el-link>
          <br />
          <el-link class="link" type="primary" href="https://www.hrbox.jp/noticeDetails001.html" target="_blank">2021/3/12 HRBOXリリース予定！</el-link>
          <br />
          <el-link class="link" type="primary" href="https://www.hrbox.jp/noticeDetails002.html" target="_blank">2021/3/16 PDF印刷の機能、社員氏名は中国語漢字を適切にサポートしています</el-link>
          <br />
          <el-link class="link" type="primary" href="https://www.hrbox.jp/noticeDetails003.html" target="_blank">2021/3/17 2021年（令和3年）3月分（4月納付分）から協会けんぽの保険料率が改定されます</el-link>
          <br />
          <el-link class="link" type="primary" href="https://www.hrbox.jp/noticeDetails004.html" target="_blank">2021/3/19 2019年（平成31年）3月分（4月納付分）から協会けんぽの保険料率が追加されます</el-link>
          <br />
          <!-- <el-link class="link" type="primary" href="/#/website/updateNews0001" target="_blank">2020/10/14 年末調整2020年版は10月リリース予定！</el-link>
          <br />
          <el-link class="link" type="primary" href="/#/introduction/main" target="_blank">2020/07/16【分析レポート】チャートを画像またはCSVでダウンロードできるようになりました</el-link>
          <br />　-->
          <el-link></el-link>
        </div>
      </el-col>
    </el-row>
    <div class="styleone">
      <h4 class="margintop"><i class="fa fa-file-text-o">&nbsp;</i>システムご利用説明</h4>
      <el-button class="fa fa-share" type="text" @click="next">&nbsp;NextStep</el-button>
      <el-steps :active="active" finish-status="success" align="left" class="step">
        <el-step title="基本台帳" description="基本台帳->会社情報のデータを新規（必須）" icon="el-icon-edit-outline"></el-step>
        <el-step title="人事管理" description="人事管理->従業員情報のデータを追加（必須）" icon="el-icon-user-solid"></el-step>
        <el-step title="給与明細計算" description="給与明細計算、給与明細書自動作成" icon="el-icon-document"></el-step>
        <el-step title="届をPDF作成" description="雇用保険などの届をPDF作成" icon="el-icon-download"></el-step>
      </el-steps>

      <!-- <el-row width="100%">
        <el-col :span="7">
          <div class="margintop">
            <el-button type="primary" @click="jump('/companyInfo')">基本台帳</el-button>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="buttontwo">
            <el-button type="primary" @click="jump('/empList')">人事管理</el-button>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="buttontwo">
            <el-button type="primary" @click="jump('/salary')">給与明細</el-button>
          </div>
        </el-col>
        <el-col :span="3">
          <div></div>
        </el-col>
      </el-row> -->

      <br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      pics: [

      ]
    };
  },

  methods: {
    jump(path) {

      this.$router.push(path);
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
  },
  mounted: function () {
    //消除后退的所有动作。包括 键盘、鼠标手势等产生的后退动作。，用户登录到系统中后，浏览器回退按钮失效，只能点击退出按钮退出系统！
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  },
};
</script>

<style scoped>
.icon_button {
  color: #20a0ff;
  font-size: 50px;
  padding-left: 50px;
  padding-right: 50px;
}

.margintop {
  margin-top: 10px;
  margin-bottom: 0px;
}

.step {
  margin-top: 0px;
  margin-bottom: 0px;
}

.buttontwo {
  margin-top: 10px;
  margin-bottom: 0px;
  margin-left: 0px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.styleone {
  margin-left: 15px;
  padding: 0px;
  text-align: left;
}

.block {
  margin-right: 25px;
  margin-left: 15px;
  margin-top: 15px;
  margin-bottom: 0px;
}

.purple-dark1 {
  margin-left: 15px;
  margin-right: 25px;
  margin-bottom: 0px;
  padding: 0px;
  text-align: left;
  border-radius: 6px;
  background: #e5e9f2;
}

.link {
  margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/HomePage.vue